import React, {useEffect} from "react"
import "./UploadProgressBar.scss"

const UploadProgressBar = ({ percent}) => {
const progressStyle = {
  width: `${percent}%`,
}

useEffect(() => {
  console.log(`percent`, percent)

}, [percent])
  return (
    <>
    <div className={`uploaded-video-item-uploadbar-wrapper`}>
    <div className={`uploaded-video-item-uploadbar-text`}>{percent < 100 ? <>Uploading...</> : <>Uploaded!</>}</div>
      <div className={`uploaded-video-item-uploadbar`}>
        <div className={`uploaded-video-item-uploadbar-progress-percent`}>{percent}%</div>
         <div className={`uploaded-video-item-uploadbar-progress`} style={progressStyle}></div>
      </div>
    </div>
    </>
  )
}

export default UploadProgressBar
